import React from 'react'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import formatPercentage from '../../utils/formatPercentage'

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '10px',
        marginBottom: '32px',
    },
    title: {
        color: "#e1465e",
        textTransform: "uppercase",
        fontWeight: 300,
        fontSize: '26px',
        textAlign: 'center'
    },
    score: {
        color: "#e1465e"
    }
}));

const PercentageCorrect = ({ acertos }) => {
    const classes = useStyles()

    return (
        <Container className={classes.root}>
            <Box marginBottom={'10px'} marginTop={'12px'} display={'flex'} justifyContent={'center'}>
                <Typography className={classes.title}>Acertos por Especialidade</Typography>
            </Box>
            {acertos.map(row => (
                <Box display='flex' justifyContent={'center'} marginRight="50px">
                    <Box width={200} textAlign={'right'} marginRight="10px">
                        <Typography> <b>{`${row.disciplina} `}</b></Typography>
                    </Box>
                    <Box width={80} >
                        <Typography>{` > ${row.respostasCorretas} de ${row.questoesDisciplina}  > `}</Typography>
                    </Box>
                    <Box width={80} >
                        <Typography className={classes.score}> {formatPercentage(row.pontos)} </Typography>
                    </Box>
                </Box>
            ))}
        </Container>
    )


}

export default PercentageCorrect 